module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-left-top-backplates-remnants.923274d8.png";